import Vue from 'vue';

export const gEventBus = new Vue();
